export const CopyCallSid = 'copy call sid';
export const DownloadRecording = 'download recording';
export const ReportCallQuality = 'report call quality';
export const SeeAutomatedSummaries = 'see automated summaries';
export const CopyMessageSid = 'copy message sid';
